
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';

@Injectable()

export class UtilityService {

//private readonly UtilityEndpoint = 'http://localhost:64330/api';
  headers: any;
private readonly UtilityEndpoint = '/api';
  constructor(private http: HttpClient) {

    this.headers = new Headers({ 'Content-Type': 'application/json' });
    this.headers.append('Content-Type', 'application/json');
    let authToken = localStorage.getItem('auth_token');
    this.headers.append('Authorization', `Bearer ${authToken}`);
  }

getLabels(componentName:string, lang:string)
{
    return this.http.get(this.UtilityEndpoint + "/Utility?componentName=" + componentName + "&lan=" + lang +"'")
    //.map(res => res.json());
  }
  getDepartments() {
    return this.http.get(this.UtilityEndpoint + "/Utility/getDepartments");
  }

  getNewStudents() {
    return this.http.get(this.UtilityEndpoint + "/Utility/getNewStudents");
  }

  getUser() {
    return this.http.get(this.UtilityEndpoint + "/Utility/getUsers");
  }

  getAccessKey() {
    return this.http.get(this.UtilityEndpoint + "/Utility/getAccessKeys");
  }

  getAccessKeyUser(userId:string ){
    return this.http.get(`${this.UtilityEndpoint }/Utility/getAccessKeyUsers?userId=${userId}`);
  }

  CreateAccessKeyUser(txn: any) {
    console.log("invoice type -->" + txn.invoiceType);
    return this.http.post(this.UtilityEndpoint + `/Utility/CreateAccessKeyUser`, txn, { headers: this.headers })
  }

  deleteAccessKeyUser(id: any) {
    return this.http.delete(this.UtilityEndpoint + `/Utility/deleteAccessKeyUser?accessKeyUserId=${id}`, { headers: this.headers })
  }

  postAccessKeyUser(dataValue: any) {
    return this.http.post(this.UtilityEndpoint + '/Utility/postAccessKeyUsers', dataValue, { headers: this.headers })
      .map(res => {
        return res;
      });
  }

  postFixAmount(dataValue: any) {
    var i = 0;
    return this.http.post(this.UtilityEndpoint + '/Utility/CreateFixAmount', dataValue, { headers: this.headers })
      .map(res => {
        return res;
      });
  }

  getFixAmount(id: string) {
    return this.http.get(this.UtilityEndpoint + '/Utility/getFixAmount/' + id, { headers: this.headers })
      .map(res => res);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/Acc_Utility.service.ts